<template>
  <div class="detalhesPlanoCliente">

       <div class="aguarde-container text-center" v-if="!objDetalhes">
        <div class="spinner-border" role="status"></div>
        <br>
        <span>Aguarde...</span>
    </div>
    <div
      v-if="objDetalhes"
      class="d-flex flex-column align-items-center m-auto"
      style="max-width:600px;"
    >
      <div class="text-center">
        <h3>{{ objDetalhes.nome }}</h3>
        <img
          :src="objDetalhes.urlImagem"
          :alt="objDetalhes.nome"
          style="width: 20vw;"
        />
        <div v-if="objDetalhes.formaAcesso === 'TELEFONE'">
          <a
            class="btn btn_color_system my-3 w-100"
            :href="`tel:${objDetalhes.dadosAcesso}`"
            @click="goTo(objDetalhes.id)"
            >{{ objDetalhes.dadosAcesso ? objDetalhes.dadosAcesso: 'TELEFONE' }}</a
          >
          <p class="text-black-50">Ligue para ser atendido</p>
        </div>
        <div v-if="objDetalhes.formaAcesso === 'WEB_SITE_INTERNO'">
          <a
            class="btn btn_color_system my-3 w-100"
            :href="isFullPath(objDetalhes.dadosAcesso) ? objDetalhes.dadosAcesso: goToInternal(objDetalhes.dadosAcesso)"
            ><span v-if="!loadingAcessar">Acessar</span>
            <span class="spinner-border" v-else></span></a
          >
        </div>
        <div v-if="objDetalhes.formaAcesso !== 'WEB_SITE_INTERNO' && objDetalhes.formaAcesso !== 'OUTROS' && objDetalhes.formaAcesso !== 'TELEFONE'">
           <a
            class="btn btn_color_system my-3 w-100"
            :href="objDetalhes.dadosAcesso"
            ><span v-if="!loadingAcessar">Acessar</span>
            <span class="spinner-border" v-else></span></a
          >
        </div>
      </div>
      <div class="mb-4" v-html="objDetalhes.descricao"></div>
      <div class="d-flex justify-content-around w-100">
        <button v-if="objDetalhes.manual" class="btn">Manual de Uso</button>
        <button v-if="objDetalhes.regulamento" class="btn">Regulamento</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetalhesPlanoClienteItem",
  props: ["objPlanoCliente"],
  data() {
    return {
      loadingAcessar: false
    };
  },
  computed: {
    objDetalhes() {
      return (this.objPlanoCliente || []).find(
        o => +o.id === +this.$route.params.idDetalhes
      );
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {},
  methods: {
    goTo(id) {
      if (this.objDetalhes.dadosAcesso && this.objDetalhes.dadosAcesso !== '' && this.objDetalhes.formaAcesso !== 'TELEFONE') {
        this.$router.push('/redirect-servicos/'+ id);
      }
    },
    goToInternal(dadosAcesso) {
      return dadosAcesso;
    },
    isFullPath(path) {
    return /^(?:\/|[a-z]+:\/\/)/i.test(path);
  }
  }
};
</script>

<style scoped lang="scss"></style>
